<template lang="pug">
    v-container(grid-list-md)
        v-layout(wrap)
            v-flex(lg3 md3 xs12)
                v-text-field(dense v-model="virtualAccount.virtualAccountNumber" label="No. Virtual Account" readonly)
            v-flex(lg6 md6 xs12)
                v-text-field(dense v-model="virtualAccount.virtualAccountName" label="Nama Virtual Account" readonly)
            v-flex(lg2 md2 xs12 v-if="virtualAccount.virtualAccountFixed")
                v-text-field(dense v-model="virtualAccount.idMember" label="ID Member"  v-if="virtualAccount.virtualAccountFixed" readonly)
        v-layout(wrap)
            v-flex(lg3 md3 xs12 v-if="virtualAccount.virtualAccountOpen")
                f-decimalbox(v-model="virtualAccount.minTransaction" label="Minimal Transaksi")
            v-flex(lg3 md3 xs12 v-if="virtualAccount.virtualAccountOpen")
                f-decimalbox(v-model="virtualAccount.maxTransaction" label="Maksimal Transaksi")
            v-flex(lg3 md3 xs12 v-if="!virtualAccount.virtualAccountOpen && !(virtualAccount.virtualAccountInvoice || virtualAccount.virtualAccountInstallment)")
                f-decimalbox(v-model="virtualAccount.amount" label="Nominal")
        v-layout(wrap v-if="virtualAccount.virtualAccountType == 'CR_ONLY' && !virtualAccount.virtualAccountInvoice && !virtualAccount.virtualAccountInstallment")
            v-flex(lg3 md3 xs12)
                f-radio-virtual-account-fixed(v-model="virtualAccountFixed" )
            v-flex(lg3 md3 xs12)
                f-radio-virtual-account-open(v-model="virtualAccount.virtualAccountOpen" :readonly="readOnly")
            v-flex(lg3 md3 xs12)
                f-radio-virtual-account-single(v-model="virtualAccount.virtualAccountSingle" :readonly="readOnly")
        v-layout(wrap v-if="virtualAccount.virtualAccountType != 'CR_ONLY'" )
            v-flex(lg12 md12 xs12)
                f-radio-virtual-account-type(v-model="virtualAccount.virtualAccountType")
        v-layout(wrap)
            v-flex(lg2 md2 xs12)
                f-date-box(v-model="dateExpired" label="Masa Berlaku VA")
            v-flex(lg2 md2 xs12)
                f-timebox(dense v-model="timeExpired")
        
        v-layout(wrap) 
            v-flex(lg12 md12 xs12 class="primary--text title-text") Data Tambahan
                v-data-table(
                    hide-default-footer
                    :headers="headers" 
                    :loading="loading"
                    loading-text="Proses mengambil data ....."
                    no-data-text="Data tidak ditemukan ....."
                    no-results-text="Data tidak ditemukan ....."
                    :items="listData"
                    :page.sync="page"
                    :items-per-page="itemsPerPage"
                    @page-count="pageCount = $event"
                    :search="criteria"
                )    
                    v-container(grid-list-md)
                        v-layout(wrap menu-btn)
                            v-spacer
                            v-flex(lg5 md5 xs12)
                                v-text-field(dense v-model="criteria" label="Filter Data Pencarian" prepend-icon="mdi-magnify" clearable)
                div(class="text-xs-center ma-2")
                    v-pagination(v-model="page" :length="pageCount")
        div(justify-center style="text-align: center" class="ma-2 menu-btn")
            v-btn(class="mx-1" @click="doCancel") Kembali
                v-icon mdi-arrow-left
</template>
<script>
export default {
    name: "FVirtualAccountContent",
    props: ["va"],
    data() {
        return {
            virtualAccount: {
                virtualAccountNumber: null,
                virtualAccountName: "",
                idMember: null,
                amount: 0,
                minTransaction: 0,
                maxTransaction: 0,
                virtualAccountFixed: true,
                virtualAccountOpen: true,
                virtualAccountSingle: false,
                virtualAccountType: "DBCR"
            },
            dateExpired: null,
            timeExpired: null,
            listData: [],
            loading: false,
            criteria: "",
            headers: [
                {text: 'KEY', value: 'key', sortable: false, width: "150px", class: "primary--text"},
                {text: 'VALUE', value: 'value', sortable: false, class: "primary--text"},
            ],
            page: 1,
            itemsPerPage: 5,
            pageCount: 0,
            item: {},
        }
    },
    watch: {
        va(val){
            this.doInit(val);
        },
        virtualAccountFixed(val){
            this.virtualAccount.virtualAccountFixed = val;
            if (!val) {
                this.virtualAccount.virtualAccountOpen = false;
                this.virtualAccount.virtualAccountSingle = true;
            }
        },
    },
    mounted() {
        this.doInit(this.va);
    },
    methods: {
        doInit(values){
            this.virtualAccount = values ? values : {
                virtualAccountNumber: null,
                virtualAccountName: "",
                idMember: null,
                amount: 0,
                minTransaction: 0,
                maxTransaction: 0,
                virtualAccountFixed: true,
                virtualAccountOpen: true,
                virtualAccountSingle: false,
                virtualAccountType: "DBCR"
            };
            this.dateExpired = this.virtualAccount.virtualAccountExpired ? this.$options.filters.localdate(this.virtualAccount.virtualAccountExpired) : null;
            this.timeExpired = this.virtualAccount.virtualAccountExpired ? this.$options.filters.timeformat(this.virtualAccount.virtualAccountExpired) : null;
            this.mapToList(this.virtualAccount.additionalData);
        },
        doCancel(){
            this.$emit("cancel");
        },
        mapToList(additional){
            this.listData = [];
            if(additional){
                for (const [key, value] of Object.entries(additional)) {
                    this.listData.push({
                        "key": key,
                        "value": value
                    })
                }
            }
        }
    },
}
</script>